/**
 * Ctermsmodal Component
 * Dedicated Terms of Service experience powered by Crisingmodal
 */

'use client';

import { Crisingmodal } from '../Crisingmodal';
import { LegalDocumentContent } from '@/components/legal/LegalDocumentContent';
import TERMS_MARKDOWN from '@/constants/legal/terms.md';

export interface CtermsmodalProps {
  visible: boolean;
  onClose: () => void;
}

export function Ctermsmodal({ visible, onClose }: CtermsmodalProps) {
  
  return (
    <Crisingmodal
      dataElScope="Ctermsmodal/Modal"
      visible={visible}
      onClose={onClose}
      onBack={onClose}

      padding={28}
    >
      <LegalDocumentContent
        content={TERMS_MARKDOWN}

      />
    </Crisingmodal>
  );
}
